/**
 * Design schema version - single source of truth (spec: CLOUD_SYNC_SPEC §9.1)
 *
 * Bump on ANY breaking change to the serializeDesign() payload, and add the
 * matching migrator to migrations.js (MIGRATIONS[oldVersion]) plus an entry
 * in docs/SCHEMA_HISTORY.md. Every stored blob (local file, autosave, cloud
 * version, published snapshot) carries this number as `version`.
 */
export const DESIGN_SCHEMA_VERSION = 2;
